import { computed, effect, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CargandoService {
  /** Lista que contiene los items que se están cargando */
  listaCarga = signal<string[]>([])
  //verListaCarga = effect(()=> logDevelopment(this.listaCarga()))

  /** Señal que muestra si algo está siendo cargado */
  cargando = computed<boolean>(()=> this.listaCarga().length ? true : false)
  
  /** Agrega un item a la lista de carga */
  agregarCarga(tipoCarga:string){
    if(this.listaCarga().includes(tipoCarga)) return;
    this.listaCarga.set([...this.listaCarga(),tipoCarga]);
  }

  /** Elimina un ítem a la lista de carga */
  eliminarCarga(tipoCarga:string){
    this.listaCarga.set(this.listaCarga().filter(item => item !== tipoCarga));
  }

  /** Revisa si la carga o cargas escritas están en la lista de 'cargando'. */
  incluye(cargas: string[] | string){
    if(typeof cargas === 'string') return this.listaCarga().includes(cargas);
    for (let i = 0; i < cargas.length; i++) {
      if(this.listaCarga().includes(cargas[i])) return true;
    }
    return false;
  }

}
